export interface DynamicRange {
  title?: string
  name: string
  num?: number
  unit?: 'day' | 'week' | 'month' | 'quarter' | 'year'
  toDate?: boolean
}

export interface DateRange {
  startDate: Date
  endDate: Date
}

export interface FixedDateRange extends DateRange {
  range?: string
  type?: 'fixed'
}
export interface DynamicDateRange {
  range?: string
  type?: 'dynamic'
  dynamic: DynamicRange
}

export type DateRangeValue = FixedDateRange | DynamicDateRange;

export enum Weekday {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}
